import React from "react";
import ReactDOM from "react-dom/client";
import App from "./common/template/App";
import reportWebVitals from "./reportWebVitals";
import webVitalsToUmami from "./webVitalsToUmami";
import { StyledEngineProvider } from "@mui/material/styles";
import { store } from "./common/state/store";
import { Provider } from "react-redux";
import { createBrowserHistory } from "history";
import "./index.css";

/* 
In the case of any 404 or 403 error, S3 will rewrite the url with a #!/ prefix (see 'S3 Static website hosting' config)
Here, we replace those urls back to human-friendly format (without #!/)

reference: https://viastudio.com/hosting-a-reactjs-app-with-routing-on-aws-s3/
relevant sof: https://stackoverflow.com/questions/51218979/react-router-doesnt-work-in-aws-s3-bucket
*/
const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
const history = createBrowserHistory();
if (path) {
  history.replace(path);
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <Provider store={store}>
        <App />
      </Provider>
    </StyledEngineProvider>
  </React.StrictMode>,
);

// Core Web Vitals → Umami events (vital-LCP, vital-CLS, ...). No-ops in local
// dev/CI (no tracker) and honors the Profile analytics opt-out — see
// webVitalsToUmami.ts.
reportWebVitals(webVitalsToUmami);
